import type { TypedUseSelectorHook } from 'react-redux';

import { useSelector } from 'react-redux';

import type { State } from '@app/store';

const useTypedSelector: TypedUseSelectorHook<State> = useSelector;

export { useTypedSelector };
